<template>
    <UILoader v-if="isModelLoading" class="modalable" />

    <div v-else class="model-modal">
        <div class="model-modal__header">
            <div class="model-modal__name">
                {{ model?.name }}
            </div>

            <router-link
                v-if="model"
                :to="{ name: 'EditModel', params: { model_id: model.id } }"
                class="model-modal__menu"
            >
                <img v-svg-inline src="@/assets/icons/ui/edit.svg" />
            </router-link>
        </div>

        <div class="model-modal__body">
            <div class="model-modal__details">
                <div class="model-modal__detail">
                    <div class="model-modal__detail-label">Марка</div>
                    <div class="model-modal__detail-value">
                        <span v-if="model?.brand_id === 1">
                            Hyundai
                        </span>

                        <span v-if="model?.brand_id === 2">
                            Genesis
                        </span>
                    </div>
                </div>

                <div class="model-modal__detail">
                    <div class="model-modal__detail-label">Дата добавления</div>
                    <div class="model-modal__detail-value">
                        {{ model && model.created_at ? formatFromUTC(model.created_at) : '-' }}
                    </div>
                </div>

                <div class="model-modal__detail">
                    <div class="model-modal__detail-label">Статус</div>
                    <div class="model-modal__detail-value">
                        {{ model ? getModelStatusLabel(model.status) : '-' }}
                    </div>
                </div>
            </div>

            <DataTable
                :headers="headers"
                :data="model?.model_codes ?? []"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue';

    import { Model, getModelStatusLabel } from '@/types/model.type.ts';

    import useLoading from '@/utils/useLoading.ts';
    import useModelRepository from '@/repositories/model/useModelRepository.ts';

    import { formatFromUTC } from '@/utils/DateTimeFormatter.ts';

    import DataTable from '@/components/shared/DataTable/DataTable.vue';

    import UILoader from '@/components/ui/UILoader/UILoader.vue';

    const { modelId } = defineProps<{
        modelId: number,
    }>();

    const { getModel } = useModelRepository();
    const { isLoading: isModelLoading, setLoading: setModelLoading } = useLoading();

    const model = ref<Model | null>(null);
    const headers = ref([
        { label: 'Код модели', key: 'model_code' },
        { label: 'Год начала производства', key: 'production_start_year' },
        { label: 'Год окончания производства', key: 'production_end_year' },
    ]);

    function fetchModel(): void {
        setModelLoading(true);

        getModel(modelId).then((fetchedModel: Model) => {
            model.value = fetchedModel;
            setModelLoading(false);
        });
    }

    onMounted(() => {
        fetchModel();
    });
</script>

<style scoped lang="scss">
    @use 'ModelModal' as *;
</style>
